import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// --- (Imports are unchanged) ---
import marathonImg1 from '../assets/images/marathon1.jpeg';
import marathonImg2 from '../assets/images/marathon2.jpeg';
import marathonImg3 from '../assets/images/marathon3.jpeg';
import marathonImg4 from '../assets/images/marathon4.jpeg';
import marathonImg5 from '../assets/images/marathon5.jpeg';
import marathonImg6 from '../assets/images/marathon6.jpeg';
import marathonImg7 from '../assets/images/marathon7.jpeg';
import marathonImg8 from '../assets/images/marathon8.jpeg';
import marathonImg9 from '../assets/images/marathon9.jpeg';
import marathonImg10 from '../assets/images/marathon10.png';
import marathonImg11 from '../assets/images/marathon11.jpeg';
import marathonImg12 from '../assets/images/marathon12.png';
import marathonImg13 from '../assets/images/marathon13.jpeg';
import marathonImg14 from '../assets/images/marathon14.jpeg';

const marathonSlides = [
    { id: 'slide1', img: marathonImg1 }, { id: 'slide2', img: marathonImg2 },
    { id: 'slide3', img: marathonImg3 }, { id: 'slide4', img: marathonImg4 },
    { id: 'slide5', img: marathonImg5 }, { id: 'slide6', img: marathonImg6 },
    { id: 'slide7', img: marathonImg7 }, { id: 'slide8', img: marathonImg8 },
    { id: 'slide9', img: marathonImg9 }, { id: 'slide10', img: marathonImg10 },
    { id: 'slide11', img: marathonImg11 }, { id: 'slide12', img: marathonImg12 },
    { id: 'slide13', img: marathonImg13 }, { id: 'slide14', img: marathonImg14 },
];

const marathonStats = [
    { distance: '5k', count: 1, bestTime: '25:42' },
    { distance: '10k', count: 8, bestTime: '53:15' },
    { distance: '21.1k', count: 12, bestTime: '1:58:45' },
    { distance: '30k', count: 7, bestTime: '3:15:00' },
    { distance: '42.2k', count: 3, bestTime: '4:39:20' },
    { distance: '50k', count: 1, bestTime: '5:32:00' },
];


const MarathonProfile = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [relatedArticles, setRelatedArticles] = useState([]);
    const [relatedVideos, setRelatedVideos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % marathonSlides.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const fetchRelatedContent = async () => {
            setIsLoading(true);
            try {
                const articlesResponse = await fetch('/api/articles/summary_list_cat/Running');
                if (articlesResponse.ok) setRelatedArticles((await articlesResponse.json()).slice(0, 4));

                const videosResponse = await fetch('/api/videos/summary_list_cat/Running');
                if (videosResponse.ok) setRelatedVideos((await videosResponse.json()).slice(0, 2));
            } catch (error) {
                console.error("Failed to fetch related content:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchRelatedContent();
    }, []);

    return (
        <div className="marathon-profile-page">
            <section className="slider-container" style={{ marginBottom: '2rem' }}>
                {/* --- GHOST IMAGE: Sets the container's aspect ratio --- */}
                <img src={marathonSlides[currentSlide].img} alt="" className="slider-ghost-image" />

                {marathonSlides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`slide ${index === currentSlide ? 'active' : ''}`}
                    >
                       <img src={slide.img} alt={`Marathon memory ${index + 1}`} className="slide-image" />
                    </div>
                ))}
            </section>

            <section>
                <h2 className="section-title">My Marathon Statistics</h2>
                <div className="marathon-stats-card">
                    <table className="stats-table">
                        <thead><tr><th>Distance</th><th>Count</th><th>Best Time</th></tr></thead>
                        <tbody>
                            {marathonStats.map((stat, index) => (
                                <tr key={index}><td>{stat.distance}</td><td>{stat.count}</td><td>{stat.bestTime}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section>
                <h2 className="section-title">Related Videos</h2>
                <div className="content-list">
                    {isLoading ? <p>Loading videos...</p> : (
                        relatedVideos.length > 0 ? relatedVideos.map((item) => (
                            <Link to={`/videos/${item.id}`} key={item.id} className="content-card">
                                <img src={item.thumbnail_url} alt={item.title} className="content-card-thumbnail" />
                                <div className="content-card-body">
                                    <h3 className="content-card-title">{item.title}</h3>
                                    <p className="content-card-description">{item.category}</p>
                                </div>
                            </Link>
                        )) : <p>No related videos found.</p>
                    )}
                </div>
            </section>

            <section>
                <h2 className="section-title">Related Articles</h2>
                <div className="content-list">
                     {isLoading ? <p>Loading articles...</p> : (
                        relatedArticles.length > 0 ? relatedArticles.map((item) => (
                            <Link to={`/articles/${item.id}`} key={item.id} className="content-card">
                                <img src={item.banner_image_url} alt={item.title} className="content-card-thumbnail" />
                                <div className="content-card-body">
                                    <h3 className="content-card-title">{item.title}</h3>
                                    <p className="content-card-description">{item.category}</p>
                                </div>
                            </Link>
                        )) : <p>No related articles found.</p>
                    )}
                </div>
            </section>
        </div>
    );
};

export default MarathonProfile;
